"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[646],{

/***/ 70646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Message; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41120);
/* harmony import */ var _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(538);
/* harmony import */ var _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57180);







var styles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _styles_jss_bbhost_pages_landingPage_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _styles_jss_bbhost_pages_landingPageSections_teamStyle_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    main: {
        background: "#f1f5f8",
        position: "relative",
        zIndex: "3",
        paddingTop: "0px"
    }
});
var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles);
function Message(props) {
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classes.section,
        style: {
            padding: "0"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: classes.title,
            style: {
                marginTop: "20px"
            },
            children: props.children
        })
    });
}


/***/ })

}]);